import InfoIcon from "@redotech/redo-icons/info-circle.svg";
import { Step } from "@redotech/redo-model/return-flow";
import { returnProcessingInformationFromModel } from "@redotech/redo-model/return-flow-step-from-model";
import {
  isReturnProcessingInformationStepValid,
  ReturnProcessingInformationState,
} from "@redotech/redo-model/return-flow-step-valid";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const RETURN_PROCESSING_INFORMATION = (
  Details: React.ComponentType<
    StepTypeDetailsProps<ReturnProcessingInformationState>
  >,
): StepType<
  ReturnProcessingInformationState,
  Step.ReturnProcessingInformation
> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) => state.header || state.message,
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: {
    header: "",
    message: "",
    continueButtonText: "",
    scope: "return_item",
  },
  fromModel: (model, id) => returnProcessingInformationFromModel(model, id),
  Icon: InfoIcon,
  iconColor: "brand",
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: "Information",
  toModel(state, id) {
    return {
      type: Step.RETURN_PROCESSING_INFORMATION,
      customTitle: state.customTitle,
      header: state.header,
      message: state.message,
      continueButtonText: state.continueButtonText,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for return-processing information step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isReturnProcessingInformationStepValid(state).valid,
});

export { type ReturnProcessingInformationState } from "@redotech/redo-model/return-flow-step-valid";
